type TabButtonProps = {
  id: string;
  target: string;
  label: string;
  active: boolean;
};

const TabButton = ({ id, target, label, active }: TabButtonProps) => (
  <li className="nav-item" role="presentation">
    <button
      className={`nav-link${active ? ' active' : ''}`}
      id={`pills-${id}-tab`}
      data-bs-toggle="pill"
      data-bs-target={`#pills-${target}`}
      type="button"
      role="tab"
      aria-controls={`pills-${target}`}
      aria-selected={active ? "true" : "false"}
    >
      {label}
    </button>
  </li>
);

const tabs = [
  { id: "rdefensor", target: "rdefensor", label: "Relatório (Defensor)", active: true },
  { id: "rdefensoria", target: "rdefensoria", label: "Relatório (Defensoria)", active: false },
  { id: "tipo", target: "tipo", label: "Agrupado por Tipo", active: false },
  { id: "defensor", target: "defensor", label: "Agrupado por Defensor", active: false },
  { id: "defensoria", target: "defensoria", label: "Agrupado por Defensoria", active: false },
];

export const TabList = () => (
  <ul className="nav nav-tabs mb-3 nav-justified" id="pills-tab" role="tablist" >
    {tabs.map((tab) => (
      <TabButton key={tab.id} {...tab} />
    ))}
  </ul>
);
